import './style.css'
import * as dat from 'dat.gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { MeshBasicMaterial, MeshMatcapMaterial, Vector2 } from 'three'

/**
 * Base
 */
// Debug

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// Raycaster
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();


function onMouseMove( event ) {

	// calculate mouse position in normalized device coordinates
	// (-1 to +1) for both components

	mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
	mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

}

const onMouseClick = ()=>{
    raycaster.setFromCamera( mouse, camera );
    const intersects = raycaster.intersectObjects( scene.children, true );
    if(intersects[0].object.name == 'button'){

        if(isButtonOn){

            isButtonOn = false
            button.position.y += 0.02
        }else{

            isButtonOn = true
            button.position.y -= 0.02
        }

       
    }
}

/**
 * Loaders
 */
// Texture loader
const textureLoader = new THREE.TextureLoader()


const bakedTexture = textureLoader.load('bakeduv.jpg')
bakedTexture.flipY = false
const matcap = textureLoader.load('matcap_metal.jpeg')



const light = new THREE.AmbientLight( 0x404040 ); // soft white light
light.intensity = 2
scene.add( light )

// Draco loader
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

/**
 * Object
 */

const bakedMaterial = new THREE.MeshBasicMaterial({map : bakedTexture, side: THREE.DoubleSide})

const pivot = new THREE.Group()
scene.add(pivot)
let fanblade
let button
let isButtonOn = true
let speed = 0.075
let speedProgress = 0

gltfLoader.load(
    'fan_noblade.glb',
    (gltf) =>{

        gltf.scene.traverse((child)=>{
            child.material = bakedMaterial
            if(child.name == 'button'){
                button = child
                button.position.y -= 0.02
            }
        })
        scene.add(gltf.scene)
    }
)



gltfLoader.load(
    'fan_blade.glb',
    (gltf) =>{
        fanblade = gltf.scene
        gltf.scene.traverse((child)=>{
            child.material = new THREE.MeshMatcapMaterial(
                {
                    matcap : matcap,
                }
            )
            // child.material = new THREE.MeshPyMaterial({
            //     envMap : envmap,
            //     // color: new THREE.Color()
            // })


            
        })
        scene.add(gltf.scene)
    }
)
// if(fanblade){
//     pivot.add(fanblade)
//     console.log(pivot)
// }

// scene.add(cube)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(30, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = 1
camera.position.z = -8
camera.lookAt(0,1,0)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.target = new THREE.Vector3(0,1,0)

controls.minAzimuthAngle = Math.PI * 0.95
controls.maxAzimuthAngle  = Math.PI * 1.05

controls.minPolarAngle  =  Math.PI * 0.25
controls.maxPolarAngle  = Math.PI * 0.5

controls.minDistance   = 0
controls.maxDistance   = 8

controls.enablePan  = false


/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,

})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    

    // console.log(mouse.x , mouse .y )

    // Update controls
    controls.update()
    if(fanblade){
        pivot.position.y = 1.49
        fanblade.position.y = -1.49
        pivot.add(fanblade)

        if(!isButtonOn && speed > 0){
            speed -= 0.001
        }
        if(isButtonOn && speed < 0.075){
            speed += 0.001
        }
        pivot.rotation.z += speed 
    }
    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}
window.addEventListener( 'mousemove', onMouseMove, false );
window.addEventListener( 'click' , onMouseClick, false )
window.addEventListener( 'touchend' , onMouseClick, false )

tick()